import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ICRoundService {
  _currentRound: BehaviorSubject<number> = new BehaviorSubject<number>(1);
  currentRound$ = this._currentRound.asObservable();

  _lastRound: BehaviorSubject<number> = new BehaviorSubject<number>(1);
  lastRound$ = this._lastRound.asObservable();

  _isInLastRound: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isInLastRound$ = this._isInLastRound.asObservable();

  constructor() {}

  setRoundInformation(currentRound: number, lastRound: number) {
    this._currentRound.next(currentRound);
    this._lastRound.next(lastRound);
    this._isInLastRound.next(currentRound === lastRound);
  }

  setCurrentRound(round?: number) {
    if (round === undefined || round < 1) {
      round = 1; // Default to round 1 if not provided or invalid
    }
    this._currentRound.next(round);
    this._isInLastRound.next(round == this._lastRound.getValue());
  }

  getCurrentRound(): number {
    return this._currentRound.getValue();
  }

  getLastRound(): number {
    return this._lastRound.getValue();
  }

  getIsInLastRound(): boolean {
    return this._isInLastRound.getValue();
  }
}
